export default __webpack_public_path__ + "static/media/unverified2.a6ba0bdd.svg";